import React, { useState } from "react";
import styles from "./EditTraining.module.css";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import {
  Dropdown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import { RiUploadCloud2Fill } from "react-icons/ri";
import { Alert, message, Upload } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import CheckBox from '../../../../../components/Checkbox/CheckBox';
import { Card, List } from 'antd';



const data = [
  {
    title: 'Mixing',
  },
  {
    title: 'Oven',
  },
  {
    title: 'Proof',
  },
  {
    title: 'Chill',
  },
  {
    title: 'Assembly',
  },
  {
    title: 'Packaging',
  },
  {
    title: 'Make Up',
  },
];



const EditTraining = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [pasteLink, setPasteLink] = useState("");
  const [assStation, setAssStation] = useState();
  const [tarRole, setTarRole] = useState();
  const [media, setMedia] = useState("");
  const { Dragger } = Upload;

  const onClickUpload = () => {
    if (!media) {
      dispatch(
        showAlert({ type: "error", message: "Media required" })
      );
    } else {
      navigate("/userManagement/training/viewTraining", {
        state: { title, pasteLink, assStation, tarRole, media },
      });
    }
    setMedia(null)
  };
  const props = {
    name: "file",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        setMedia(info.file);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };


  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };


  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Edit Training Media"}
        showBackIcon={true}
        showFilterIcon={false}
        showSubmitButton={false}
        showSearch={false}
      />
      <div className={styles.contentCont}>
        <InputField
          className={styles.inputNew}
          label={"Title"}
          placeholder={"Bread Flour"}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <InputField
          className={styles.inputNew}
          label={"Paste Link"}
          placeholder={"htttp/exmaple.com"}
          value={pasteLink}
          onChange={(e) => setPasteLink(e.target.value)}
        />
        {/* <Dropdown
          className={styles.inputNew}
          label={"Assigned Station"}
          placeholder={"PDF for manuals, spec sheets"}
          value={assStation}
          style={{ color: "black" }}
          options={[
            {
              value: "Mixing",
              id: 1,
            },
          ]}
          onChange={(e) => setAssStation(e)}
        /> */}

        <Dropdown
          className={styles.inputNew}
          label={"Target Role"}
          placeholder={"Both"}
          value={tarRole}
          // labelStyle={{ fontSize: 18 }}
          style={{ color: "black" }}
          options={[
            { value: "Supervisor", id: 1 },
            { value: "Manager", id: 2 },
            {
              value: "Both",
              id: 3,
            },
          ]}
          onChange={(e) => setTarRole(e)}
        />


        <TextComponent text={"Assigned Station"} className={styles.stationText} />
        <div style={{ marginTop: 10 }}>

          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 2,
              md: 3,
              lg: 3,
              xl: 4,
              xxl: 3,
            }}
            dataSource={data}
            renderItem={item => (
              <List.Item>
                <CheckBox onClick={onChange}>{item.title}</CheckBox>
              </List.Item>
            )}
          />
        </div>
        <div className={styles.dragger}>
          <TextComponent
            text={"Upload Media"}
            className={styles.draggerHeading}
          />
          <Dragger {...props}>
            <div className={styles.draggerInner}>
              <RiUploadCloud2Fill color="var(--light-grey)" size={30} />
              <TextComponent
                className={styles.draggerText}
                text={"Click or drag file to this area to upload"}
              />
            </div>
          </Dragger>
        </div>
        <SubmitButton
          title={"Upload"}
          primary
          btnClass={styles.uploadBtn}
          onClick={onClickUpload}
        />
      </div>
    </div>
  );
};

export default EditTraining;
